import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faSave } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { Controls } from 'src/app/controls/forms/managed-form/ngx-sub-form-utils';
import { DataInput } from 'src/app/controls/forms/management-form/form.decorators';
import { ManagementFormComponent } from 'src/app/controls/forms/management-form/management-form';
import { IDocumentType } from 'src/app/models/interfaces/document-type.interface';
import { FormFocusDirective } from '../../../controls/directives/form-focus.directive';
import { DocumentTypeFormContext } from '../document-type-form-context';

@Component({
    selector: 'app-document-type-form',
    templateUrl: './document-type-form.component.html',
    styleUrls: ['./document-type-form.component.scss'],
    imports: [
        FormsModule,
        FormFocusDirective,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        FaIconComponent,
        MatTooltipModule,
        MatSelectModule,
        MatOptionModule,
        MatButtonModule,
        NgClass,
    ]
})
export class DocumentTypeFormComponent extends ManagementFormComponent<IDocumentType> implements OnInit, OnChanges {
    public faSave = faSave;
    public faCircleInfo = faCircleInfo;

    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Infos du client à afficher dans le formulaire.
     */
    @DataInput()
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('documentType')
    public dataInput: Required<IDocumentType> | null | undefined;

    /**
     * Contexte du formulaire (mode d'affichage ...).
     */
    public _context: DocumentTypeFormContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<DocumentTypeFormContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: DocumentTypeFormContext) {
        this._context$.next(value);
    }

    /*
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output('documentTypeUpdated')
    public dataOutput: EventEmitter<IDocumentType> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Initialise le composant.
     */
    override ngOnInit() {
        super.ngOnInit();

        // S'abonne aux changements de contexte
        this._context$.subscribe((x) => {
            this._context = x;
            this.dataInput$.next(x.item);
        });
    }

    /**
     * Utilisé pour rendre le champ id read-only
     */
    ngOnChanges() {
        this.formGroup.get('id').disable();
    }

    /**
     * Retourne la liste des contrôles du formulaire
     */
    protected getFormControls(): Controls<IDocumentType> {
        return {
            id: new UntypedFormControl(null, Validators.required),
            name: new UntypedFormControl(null, Validators.required),
            defaultBoxId: new UntypedFormControl(null, Validators.required),
        };
    }

    /**
     *  Appellé lorsque l'utilisateur clique sur le bouton 'sauver'
     */
    public override manualSave(): void {
        super.manualSave();
    }

    public cancel(): void {
        this.canceled.emit(true);
    }
}
